import React, { useEffect, useState } from 'react';

export default function SplashScreen() {
  const [visible, setVisible] = useState(() => {
    if (typeof window === 'undefined') return true;
    return !sessionStorage.getItem('gicleanly_splash_seen');
  });

  useEffect(() => {
    if (!visible) return;
    const t = setTimeout(() => {
      sessionStorage.setItem('gicleanly_splash_seen', '1');
      setVisible(false);
    }, 1600);
    return () => clearTimeout(t);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="uc-splash">
      <img src="/logo/gicleanly-logo.jpg" alt="GiCleanly" className="uc-splash-logo" />
      <div className="uc-splash-bar" />
      <p className="uc-splash-text">CLEAN SPACES, DEEP CLEAR</p>
    </div>
  );
}
